import { useEffect } from "react";

interface KeyboardShortcuts {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFit: () => void;
  onReset: () => void;
}

export const useKeyboardShortcuts = (shortcuts: KeyboardShortcuts) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Prevent shortcuts when typing in input fields
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      switch (e.key.toLowerCase()) {
        case "+":
        case "=":
          e.preventDefault();
          shortcuts.onZoomIn();
          break;
        case "-":
          e.preventDefault();
          shortcuts.onZoomOut();
          break;
        case "f":
          e.preventDefault();
          shortcuts.onFit();
          break;
        case "r":
          e.preventDefault();
          shortcuts.onReset();
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [shortcuts]);
};
